/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */
import { useEffect, useState } from "react";
import { connect } from "react-redux";

// Formik and Yup
import { useFormik } from "formik";
import * as Yup from "yup";

// Utils component
import TextError from "utils/TextError";

// Dashboard example components
import DataTable from "examples/Tables/DataTable";

// Dashboard components
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";
import MDCard from "components/MDCard";

// @mui material components
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Card from "@mui/material/Card";
import Modal from "@mui/material/Modal";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Alert from "@mui/material/Alert";
import Collapse from "@mui/material/Collapse";
import Grid from "@mui/material/Grid";
import CircularProgress from "@mui/material/CircularProgress";

import { CustomToastContent } from "../../../examples/CustomToastContent/index";

// import Icon from "@mui/material/Icon";
import CloseIcon from "@mui/icons-material/Close";
import Icon from "@mui/material/Icon";

// React-Select component and styling
import Select from "react-select";

//  config file
import Config from "../../../config/index";

// Functions from store
import {
  getWarehouses,
  getFgOperation,
  getItemMaster,
  getZonesByWarehouse,
  getOpenBinsByWarehouseAndZone,
  getSubModulesByRoleId,
  getLevel1ByLevel,
  getLevel2ByLevel,
  getLevel3ByLevel,
  getLevel4ByLevel,
  getAcn,
  createFG,
  uploadForProduction,
  getRelationLocation,
  getWarehousesByMovement,
  deletefG,
  editFg,
  getUsersForFG,
  getDppIds,
  getInsertPoNumberProduction,
  getPoNumberByDppId,
  getDynamicColumn,
  createDynamicColumn,
} from "../../../store";

// Cookies
import Cookies from "universal-cookie";
import CreateButton from "components/standardized-components/CreateButton";
import DeleteButton from "components/standardized-components/DeleteButton";
import EditButton from "components/standardized-components/EditButton";
import { addMinutes, format } from "date-fns";
import { Backdrop } from "@mui/material";
import MDInput from "components/MDInput";
import { CSVLink } from "react-csv";
import DownloadDataButton from "components/standardized-components/DownloadDataButton";
import UploadButton from "components/standardized-components/UploadButton";
import DownloadButton from "components/standardized-components/DownloadButton";

const cookies = new Cookies();

const desLength = Config.descriptionLength;

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: 350, lg: 800 },
  height: "fit-content",
  maxHeight: "90%",
  boxShadow: 24,
  p: 0,
  pt: 2,
  overflow: "auto",
  // overflowX: "hidden",
};

const styleForEdit = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: 350, lg: 800 },
  height: "fit-content",
  maxHeight: "90%",
  boxShadow: 24,
  p: 1,
  pt: 3,
  overflow: "auto",
  // overflowX: "hidden",
};

const deleteStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 350,
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const FGOPERATIONLOG = ({
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,

  createDynamicColumn,
  getWarehouses,
  deletefG,
  warehouses,
  getFgOperation,
  getFgOperationReducer,
  getItemMaster,
  getDynamicColumn,
  itemMaster,
  getZonesByWarehouse,
  zonesByWarehouse,
  getOpenBinsByWarehouseAndZone,
  getRelationLocationReducer,
  getLevel1ByLevel,
  getWarehouseByMovementReducer,
  getLevel2ByLevel,
  getLevel3ByLevel,
  getLevel1ByLevelReducer,
  getLevel2ByLevelReducer,
  getLevel3ByLevelReducer,
  getLevel4ByLevel,
  getUsersForFGReducer,
  editFg,
  getAcn,
  getAcnReducer,
  getRelationLocation,
  createFG,
  getWarehousesByMovement,
  uploadForProduction,
  getUsersForFG,
  levelsByWarehouseReducer,
  getDppIds,
  getDynamicColumnReducer,
  getDPPReducer,
  dppIdSelectedForGlobalFilter,
  getInsertPoNumberProduction,
  getPOnumberFGReducer,
  getPOnumberReducer,
  getPoNumberByDppId
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");
  let jwtToken = loginDetails?.jwt;
  let roleId = loginDetails.data.roleId;

  let userId = loginDetails.data.userId;

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);
  const styleForColumnReorder = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 380,
    color: "black",
    // border: "2px solid #000",
    boxShadow: 24,
    p: 2,
    pt: 3,
  };

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : []
    );
  }, [getSubModulesByRoleIdReducer]);

  let ItemLocationMapping = modulesData.find(
    (moduleId) => moduleId.moduleId == "3a6c5d90-c26f-45c5-9294-3dd13df1b2d5"
  );

  let allocateAccess = ItemLocationMapping
    ? ItemLocationMapping.actionId.includes(
      "12ea0834-4eb3-4e95-ab2d-adf17f051fb2"
    )
    : null;

  let viewAccess = ItemLocationMapping
    ? ItemLocationMapping.actionId.includes(
      "791b1b5d-5a9e-4068-8220-4dc001e46f45"
    )
    : null;
  let editAccess = ItemLocationMapping
    ? ItemLocationMapping.actionId.includes(
      "c8effc82-b12d-48c3-b69a-95a5a8f72e28"
    )
    : null;
  let deleteAccess = ItemLocationMapping
    ? ItemLocationMapping.actionId.includes(
      "988e3ca9-6bca-40f2-9efe-12f5474d2c0c"
    )
    : null;

  const [pageNo, setPageNo] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchObject, setSearchObject] = useState(JSON.stringify({}));
  const [paginationObj, setPaginationObj] = useState({});
  const [errorMsgFromApi, setErrorMsgFromApi] = useState("");
  const [uncheck, setUncheck] = useState(false);

  const importPageNo = (pageIndex) => {
    setPageNo(pageIndex === -1 ? pageNo : pageIndex);
  };

  const importRowsPerPage = (pageSize) => {
    setRowsPerPage(pageSize);
  };

  const importSearch = (globalFilter) => {
    setSearchObject(globalFilter ? JSON.stringify(globalFilter) : "");
  };
  const [refresh, setRefresh] = useState("");
  // setTimeout(() => {
  //   setRefresh(!refresh);
  // }, 60000);

  const [warehouseIdSelected, setWarehouseIdSelected] = useState("");
  const [zoneIdSelected, setZoneIdSelected] = useState("");
  const [sectionIdSelected, setSectionIdSelected] = useState("");
  const [rackIdSelected, setRackIdSelected] = useState("");
  const [locationIdSelected, setLocationIdSelected] = useState("");
  const [activityIdSelected, setActivityIdSelected] = useState("");

  const handleActivityIdChange = (selectedActivity) => {
    setActivityIdSelected(selectedActivity);
    setWarehouseIdSelected("");
  };

  const handleChangeWarehouse = (selectedData) => {
    setWarehouseIdSelected(selectedData);
    setZoneIdSelected("");
    setSectionIdSelected("");
    setRackIdSelected("");
    setLocationIdSelected("");
  };

  const handleZoneIDChange = (selectedRack) => {
    setZoneIdSelected(selectedRack);
    setSectionIdSelected("");
    setRackIdSelected("");
    setLocationIdSelected("");
  };

  const handleSectionIdChange = (selectedRack) => {
    setSectionIdSelected(selectedRack);
    setRackIdSelected("");
    setLocationIdSelected("");
  };
  const handleRackIdChange = (selectedRack) => {
    setRackIdSelected(selectedRack);
    setLocationIdSelected("");
  };

  const handleLocationIdChange = (selectedLocation) => {
    setLocationIdSelected(selectedLocation);
  };

  const [selectedZoneName, setSelectedZoneName] = useState("");

  const handleZoneNameChange = (selectedZoneName) => {
    setSelectedZoneName(selectedZoneName);
    setRackIdSelected("");
  };

  // useEffect(() => {
  //   getFgOperation(jwtToken);
  // }, []);

  const [state, setState] = useState({
    columns: [
      // { Header: "fg Op Id", accessor: "fgOpId" },
      { Header: "DPP Code", accessor: "productCode" },
      { Header: "plant", accessor: "plant" },
      { Header: "Order", accessor: "prdOrder" },

      { Header: "Melt/Heat Number", accessor: "meltHeatNumber" },
      { Header: "Qty", accessor: "fgQty" },
      { Header: "operation Code", accessor: "operationCode" },
      { Header: "workCenter", accessor: "workCenter" },
      { Header: "Parameters", accessor: "machineParameters" },
      // { Header: "picklist Id", accessor: "picklistId" },
      // { Header: "user Id", accessor: "userId" },
      // { Header: "status", accessor: "status" , cannotSearch: true,
      //   cannotSort: true, },

      {
        Header: "rmIssue Date",
        accessor: "rmIssueDate",
        align: "left",
        searchType: "date",
        Cell: ({ value }) => {
          return value
            ? format(new Date(value), "dd/MM/yyyy")
            : "";
        },
      },
      {
        Header: "pouring/casting date",
        accessor: "pouringCastingDate",
        align: "left",
        searchType: "date",
        Cell: ({ value }) => {
          return value
            ? format(new Date(value), "dd/MM/yyyy")
            : "";
        },
      },
      { Header: "production Batch", accessor: "prdCode" },

      { Header: "Material Grade", accessor: "materialGrade" },
      { Header: "user", accessor: "user" },
      {
        Header: "Completion Date",
        accessor: "fgCompletionDate",
        align: "left",
        searchType: "date",
        Cell: ({ value }) => {
          return value
            ? format(new Date(value), "dd/MM/yyyy")
            : "";
        },
      },
      { Header: "electricity Consumption", accessor: "electricityConsumption" },
      { Header: "carbon Footprint (kg CO₂e) ", accessor: "carbonFootprint" },
      { Header: "water Consumption (L)", accessor: "waterConsumption" },
      { Header: "made In", accessor: "madeIn" },

      { Header: "production/casting batch", accessor: "productionCastingBatch" },
      { Header: "Casting Process", accessor: "castingProcess" },


      // { Header: "Created By", accessor: "cdBy" },
      {
        Header: "Action",
        accessor: "action",
        cannotSearch: true,
        cannotSort: true,
      },
    ],
    rows: [],
  });

  const headers = [
    { label: "DPP Code", key: "dppCode" },
    { label: "Production Plant", key: "productionPlant" },
    { label: "Production Order Number", key: "productionOrderNumber" },
    { label: "FG Quantity", key: "fgQuantity" },
    { label: "Operation Code", key: "operationCode" },
    { label: "Operation Completion Date", key: "operationCompletionDate" },
    { label: "Work Center", key: "workCenter" },
    { label: "Machine Code", key: "machineCode" },
    { label: "Machine Parameters", key: "machineParameters" },
    { label: "RM Issue Date", key: "rmIssueDate" },
    { label: "Production Code", key: "productionCode" },
    { label: "Production End Date", key: "productionEndDate" },
    { label: "Carbon Footprint", key: "carbonFootprint" },
    { label: "Electricity Consumption", key: "electricityConsumption" },
    { label: "Water Consumption", key: "waterConsumption" },
    { label: "Made In Country Name", key: "madeInCountryName" },
    { label: "Quality Yield", key: "qualityYield" },
    { label: "Waste Generated", key: "wasteGenerated" },
    { label: "Melt Heat Number", key: "meltHeatNumber" },
    { label: "Production Casting Batch", key: "productionCastingBatch" },
    { label: "Material Grade", key: "materialGrade" },
    { label: "Casting Process", key: "castingProcess" },
    { label: "Pouring Casting Date", key: "pouringCastingDate" },
    { label: "Operation Assigned User Name", key: "operationAssignedUserName" }
  ];

  const headersForTemp = [
    { label: "dppCode", key: "dppCode" },
    { label: "productionPlant", key: "productionPlant" },
    { label: "productionOrderNumber", key: "productionOrderNumber" },
    { label: "fgQuantity", key: "fgQuantity" },
    { label: "operationCode", key: "operationCode" },
    { label: "operationCompletionDate", key: "operationCompletionDate" },
    { label: "workCenter", key: "workCenter" },
    { label: "machineCode", key: "machineCode" },
    { label: "machineParameters", key: "machineParameters" },
    { label: "rmIssueDate", key: "rmIssueDate" },
    { label: "productionCode", key: "productionCode" },
    { label: "productionEndDate", key: "productionEndDate" },
    { label: "carbonFootprint", key: "carbonFootprint" },
    { label: "electricityConsumption", key: "electricityConsumption" },
    { label: "waterConsumption", key: "waterConsumption" },
    { label: "madeInCountryName", key: "madeInCountryName" },
    { label: "qualityYield", key: "qualityYield" },
    { label: "wasteGenerated", key: "wasteGenerated" },
    { label: "meltHeatNumber", key: "meltHeatNumber" },
    { label: "productionCastingBatch", key: "productionCastingBatch" },
    { label: "materialGrade", key: "materialGrade" },
    { label: "castingProcess", key: "castingProcess" },
    { label: "pouringCastingDate", key: "pouringCastingDate" },
    { label: "operationAssignedUserName", key: "operationAssignedUserName" }
  ];

  const { columns, rows } = state;

  const csvLink = {
    filename: "Production List.csv",
    headers: headers,
    data: rows,
  };

  const csvLink2 = {
    filename: "Production Template.csv",
    headers: headersForTemp,
    data: [],
  };

  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let tempMappedActivity = [];
    let data = getFgOperationReducer.fgOperation.data
      ? getFgOperationReducer.fgOperation.data
      : [];
    // setPaginationObj(getFgOperationReducer?.passPort?.pagination);
    setLoading(getFgOperationReducer.loading);

    data.map((item) => {
      const formatDate = new Date(item.fgCompletionDate);
      const formatDate2 = new Date(item.rmIssueDate);

      const formatCastingDate = item.pouringCastingDate ? new Date(item.pouringCastingDate) : null;
      let itemDescription = item.itemDescription;
      let len = desLength;

      const itemObject = {
        privateKey: item.itemCode,
        itemCodeDes: `${item.itemCode} / ${itemDescription ? itemDescription.substring(0, len) : ""
          }`,
        fgCompletionDate: item.fgCompletionDate,
        productCode: item.productCode,
        fgOpId: item.fgOpId,
        electricityConsumption: item.electricityConsumption,
        madeIn: item.madeIn,
        waterConsumption: item.waterConsumption,
        prdOrder: item.prdOrder,
        carbonFootprint: item.carbonFootprint,
        userId: item.userId,
        plant: item.plant,
        prdCode: item.prdCode,
        user: item.name,
        rmIssueDate: item.rmIssueDate,
        fgQty: item.fgQty,
        machineParameters: item.machineParameters,
        operationCode: item.operationCode,
        workCenter: item.workCenter,

        meltHeatNumber: item.meltHeatNumber,
        productionCastingBatch: item.productionCastingBatch,
        materialGrade: item.materialGrade,
        castingProcess: item.castingProcess, 
        pouringCastingDate: item.pouringCastingDate,

        status: (
          <button
            type="button"
            className={
              (item.status === 1 && `status-success`) ||
              (item.status === 0 && `status-error`) ||
              (item.status === 2 && `status-warning`)
            }
            style={{ width: "7rem", cursor: "pointer" }}
          >
            {(item.status === 1 && `Active`) ||
              (item.status === 0 && `Inactive`) ||
              (item.status === 2 && `Unarchived`)}
          </button>
        ),

        itemDescription: (
          <span style={{ display: "flex", alignItems: "center" }}>
            {item?.itemDescription?.length > 35 ? (
              <Tooltip
                title={item.itemDescription}
                style={{ cursor: "pointer" }}
              >
                <MDTypography
                  variant="h6"
                  fontWeight="regular"
                  style={{ fontSize: "14px" }}
                >
                  {item.itemDescription.substring(0, len)}
                </MDTypography>
              </Tooltip>
            ) : (
              <MDTypography
                variant="h6"
                fontWeight="regular"
                style={{ fontSize: "14px" }}
              >
                {item.itemDescription}
              </MDTypography>
            )}
            {item?.itemDescription?.length > 35 && (
              <span style={{ marginLeft: "0.1rem" }}>...</span>
            )}
          </span>
        ),

        id: item.id,
        categoryCode: item.categoryCode,
        warehouse: item.warehouseCode,
        zone: item.zone,
        section: item.section,

        createdDate: format(new Date(formatDate), "dd/MM/yyyy"),

        createdDate2: format(new Date(formatDate2), "dd/MM/yyyy"),

        cd: item.cd,
        rack: item.rack,
        location: item.location,
        // itemName: des ? des.substring(0, len) : "",
        acnCode: item.acnCode,
        action: (
          <>
            {deleteAccess && (
              <DeleteButton
                tooltip="Delete"
                variant="gradient"
                color="error"
                iconOnly
                type="button"
                style={{ marginRight: "5px" }}
                onClick={() => handleOpenDeleteModal(item)}
              >
                <Icon>delete</Icon>
              </DeleteButton>
            )}
            {editAccess && (
              <EditButton
                tooltip="Edit"
                variant="gradient"
                color="success"
                iconOnly
                type="button"
                onClick={() => {
                  handleOpenUpdateModal(item);
                }}
                style={{ marginRight: "5px" }}
              >
                <Icon>edit_sharp</Icon>
              </EditButton>
            )}
          </>
        ),
      };
      tempMappedActivity.push(itemObject);
    });

    viewAccess && setState({ ...state, rows: tempMappedActivity });
  }, [getFgOperationReducer]);

  const [activityOptions, setActivityOptions] = useState([]);

  useEffect(() => {
    let tempActivityOptions = [];
    let data = getAcnReducer.acn.data ? getAcnReducer.acn.data : [];
    data.map((activity) => {
      tempActivityOptions.push({
        label: activity.acnName,
        value: activity.acnId,
      });
    });
    setActivityOptions(tempActivityOptions);
  }, [getAcnReducer]);

  const [warehouseOptions, setWarehouseOptions] = useState([]);
  useEffect(() => {
    let tempWarehouseOptions = [];
    let data = warehouses.warehouses ? warehouses.warehouses : [];
    data.map((warehouse) => {
      tempWarehouseOptions.push({
        label: warehouse.warehouseCode,
        value: warehouse.warehouseId,
      });
    });
    setWarehouseOptions(tempWarehouseOptions);
  }, [warehouses]);

  const [warehouseOptionsByMovement, setWarehouseOptionsByMovement] = useState(
    []
  );

  useEffect(() => {
    let tempWarehouseOptions = [];
    let data = getWarehouseByMovementReducer.warehouses.data
      ? getWarehouseByMovementReducer.warehouses.data
      : [];
    data.map((warehouse) => {
      tempWarehouseOptions.push({
        label: warehouse.warehouseCode,
        value: warehouse.warehouseId,
      });
    });
    setWarehouseOptionsByMovement(tempWarehouseOptions);
  }, [getWarehouseByMovementReducer]);
  // useEffect(() => {
  //   let tempLevelOptions = [];
  //   let data = getRelationLocationReducer.locations.data
  //     ? getRelationLocationReducer.locations.data
  //     : [];

  //   data.map((level) => {
  //     tempLevelOptions.push({
  //       label: level.rltName,
  //       value: level.rltLevel,
  //     });
  //   });
  //   setLevelOptions(tempLevelOptions);
  // }, [getRelationLocationReducer]);

  // let level1Name = getRelationLocationReducer.locations.data

  const [itemCodeOptions, setItemCodeOptions] = useState([]);

  useEffect(() => {
    let tempItemCodeOptions = [];
    let data = itemMaster.itemMaster.data ? itemMaster.itemMaster.data : [];
    data.map((item) => {
      let des = item?.itemDescription;
      let len = desLength;
      tempItemCodeOptions.push({
        label: `${item.itemCode} / ${des ? des.substring(0, len) : ""}`,
        value: item.itemId,
      });
    });
    setItemCodeOptions(tempItemCodeOptions);
  }, [itemMaster]);

  const [zoneOptions, setZoneOptions] = useState([]);

  useEffect(() => {
    let tempZonesByWarehouse = [];
    let data = zonesByWarehouse.zones.data ? zonesByWarehouse.zones.data : [];
    data.map((zone) => {
      tempZonesByWarehouse.push({
        label: zone.zoneName,
        value: zone.id,
      });
    });
    setZoneOptions(tempZonesByWarehouse);
  }, [zonesByWarehouse]);

  useEffect(() => {
    getUsersForFG(jwtToken);
  }, []);

  const [levelOptions, setLevelOptions] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = levelsByWarehouseReducer.levelsByWarehouse.data
      ? levelsByWarehouseReducer.levelsByWarehouse.data
      : [];

    data.map((level) => {
      tempLevelOptions.push({
        label: level?.rltName,
        value: level?.rltLevel,
      });
    });
    setLevelOptions(tempLevelOptions);
  }, [levelsByWarehouseReducer]);

  const [level1Options, setLevel1Options] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = getLevel1ByLevelReducer.level1ByLevel.data
      ? getLevel1ByLevelReducer.level1ByLevel.data
      : [];
    data.map((level) => {
      tempLevelOptions.push({
        label: level.locationName,
        value: level.locationId,
      });
    });

    setLevel1Options(tempLevelOptions);
  }, [getLevel1ByLevelReducer]);

  const [level2Options, setLevel2Options] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = getLevel2ByLevelReducer.level2ByLevel.data
      ? getLevel2ByLevelReducer.level2ByLevel.data
      : [];
    data.map((level) => {
      tempLevelOptions.push({
        label: level.locationName,
        value: level.locationId,
      });
    });

    setLevel2Options(tempLevelOptions);
  }, [getLevel2ByLevelReducer]);

  const [level3Options, setLevel3Options] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = getLevel3ByLevelReducer.level3ByLevel.data
      ? getLevel3ByLevelReducer.level3ByLevel.data
      : [];

    data.map((level) => {
      tempLevelOptions.push({
        label: level.locationName,
        value: level.locationId,
      });
    });

    setLevel3Options(tempLevelOptions);
  }, [getLevel3ByLevelReducer]);

  const [userOptions, setUsersOptions] = useState([]);

  useEffect(() => {
    let tempLevelOptions = [];
    let data = getUsersForFGReducer.users.data
      ? getUsersForFGReducer.users.data
      : [];

    data.map((level) => {
      tempLevelOptions.push({
        label: level.userName,
        value: level.id,
      });
    });

    setUsersOptions(tempLevelOptions);
  }, [getUsersForFGReducer]);

  const [openBinsOptions, setOpenBinsOptions] = useState([]);

  const [isSuccessAllocateItem, setIsSuccessAllocateItem] = useState(false);
  const [isErrorAllocateItem, setIsErrorAllocateItem] = useState(false);

  useEffect(() => {
    if (isSuccessAllocateItem) {
      setTimeout(() => {
        setIsSuccessAllocateItem(false);
      }, 3000);
    }
  }, [isSuccessAllocateItem]);

  useEffect(() => {
    if (isErrorAllocateItem) {
      setTimeout(() => {
        setIsErrorAllocateItem(false);
      }, 3000);
    }
  }, [isErrorAllocateItem]);

  const [allocateItemModal, setAllocateItemModal] = useState(false);
  const handleAllocateItemModal = () => {
    setAllocateItemModal(!allocateItemModal);

    setUserSelected("");

    formik.setErrors({});

    setZoneIdSelected("");
    setWarehouseIdSelected("");
    setSectionIdSelected("");



  };
  const handleCloseAllocateItemModal = (event, reason) => {
    if (reason === "backdropClick")
      return;
    setAllocateItemModal(!allocateItemModal);
    setdppIdSelected("");
    formik.setErrors({});
    setUserSelected("");

    formik.setValues(initialValues);
    setWarehouseIdSelected("");
    setLocationIdSelected("");
    setActivityIdSelected("");
    setSelectedItemCode("");
  };

  const [ActivityMappingData, setActivityMappingData] = useState({});

  const [selectedItemCode, setSelectedItemCode] = useState("");

  const handleItemCodeChange = (selectedItemCode) => {
    setSelectedItemCode(selectedItemCode);
  };

  const [selectedBin, setSelectedBin] = useState("");

  const handleBinChange = (selectedBin) => {
    setSelectedBin(selectedBin);
  };
  const [selectedBinForAdd, setSelectedBinForAdd] = useState("");

  const handleBinChangeForAdd = (selectedBinForAdd) => {
    setSelectedBinForAdd(selectedBinForAdd);
  };

  const [selectedOpenBin, setSelectedOpenBin] = useState(
    ActivityMappingData?.locationName
  );

  useEffect(() => {
    if (ActivityMappingData) {
      setSelectedOpenBin({
        label: ActivityMappingData?.locationName,
        value: ActivityMappingData?.locationName,
      });
    }
  }, [ActivityMappingData]);

  const handleOpenBinChange = (selectedOpenBin) => {
    setSelectedOpenBin(selectedOpenBin);
  };


  const initialValues = {
    // DPPID: "",
    Plant: "",
    ProductionOrder: "",
    ProductionCode: "",
    Quantity: null,
    Operation: "",
    WorkCenter: "",
    Parameters: "",
    ProductionDate: null,
    CompletionDate: null,
    User: "",
    carbonFootprint: "",
    electricityConsumption: null,
    waterConsumption: null,
    madeIn: "",
    qualityYield: "",
    wasteGenerated: "",
    meltHeatNumber: "",
    productionCastingBatch: "",
    materialGrade: "",
    castingProcess: "",
    pouringCastingDate: "",

  };
  const validationSchema = Yup.object({
    //  DPPID: Yup.object()
    //      .required("Select DPP Code"),

    Plant: Yup.string()
      .trim()
      .required(" "),

    ProductionOrder: Yup.string()
      .trim()
      .required(" "),

    ProductionCode: Yup.string()
      .trim()
      .required(" "),

    Quantity: Yup.number()
      .typeError("Quantity must be a number")
      .required(" "),

    Operation: Yup.string()
      .trim()
      .required(" "),

    WorkCenter: Yup.string()
      .trim()
      .required(" "),

    Parameters: Yup.string()
      .trim()
      .required(" "),

    ProductionDate: Yup.date()
      .nullable()
      .typeError("Production Date must be a valid date")
      .required(" "),

    CompletionDate: Yup.date()
      .nullable()
      .typeError("Completion Date must be a valid date")
      .required(" "),


    User: Yup.object().required(" "),

    carbonFootprint: Yup.string()
      .trim()
      .required(" "),

    electricityConsumption: Yup.number()
      .nullable()
      .typeError(" ")
      .required(" "),

    waterConsumption: Yup.number()
      .nullable()
      .typeError(" ")
      .required(" "),

    madeIn: Yup.string()
      .trim()
      .required(" "),

    qualityYield: Yup.string()
      .trim()
      .required(" "),

    wasteGenerated: Yup.string()
      .trim()
      .required(" "),

    meltHeatNumber: Yup.string()
      .trim()
      .matches(/^[a-zA-Z0-9-]+$/, "Only alphanumeric and hyphens are allowed")
      .required(" "),

    productionCastingBatch: Yup.string()
      .trim()
      .matches(/^[a-zA-Z0-9-]+$/, "Only alphanumeric and hyphens are allowed")
      .required(" "),

    materialGrade: Yup.string()
      .trim()
      .matches(/^[a-zA-Z0-9-]+$/, "Only alphanumeric and hyphens are allowed")
      .required(" "),

    castingProcess: Yup.string()
      .trim()
      .matches(/^[a-zA-Z\s]+$/, "Only characters and spaces are allowed")
      .required(" "),

    pouringCastingDate: Yup.string()
      .trim()
      .matches(/^\d{4}-\d{2}-\d{2}$/, "Date must be in YYYY-MM-DD format")
      .required(" "),
  });


  const [dppIdSelected, setdppIdSelected] = useState("");
  const handleChangeDpp = (selectedData) => {
    setdppIdSelected(selectedData);

  };


  useEffect(() => {
    if (dppIdSelectedForGlobalFilter) {
      setdppIdSelected(dppIdSelectedForGlobalFilter);
    }
  }, [dppIdSelectedForGlobalFilter]);




  useEffect(() => {
    if (dppIdSelectedForGlobalFilter?.value) {
      // Fetch with dppId + jwtToken
      getFgOperation(dppIdSelectedForGlobalFilter?.value, jwtToken);
    } else {
      // Fetch without filter
      getFgOperation(null, jwtToken);
    }
  }, [dppIdSelectedForGlobalFilter, jwtToken]);


  const [userSelected, setUserSelected] = useState("");
  const handleChangeUser = (selectedData) => {
    setUserSelected(selectedData);
  };
  const [userForUpdateSelected, setUserForUpdateSelected] = useState("");
  const handleChangeUserForUpdate = (selectedData) => {
    setUserForUpdateSelected(selectedData);
  };

  const [dppOptions, setDPPOptions] = useState([]);

  useEffect(() => {
    let tempgetDPPReducer = [];
    let data = getDPPReducer.dpp.data ? getDPPReducer.dpp.data : [];
    data.map((zone) => {
      tempgetDPPReducer.push({
        label: zone.dppCode,
        value: zone.dppId,
      });
    });
    setDPPOptions(tempgetDPPReducer);
  }, [getDPPReducer]);

  const [dppIdForUpdateSelected, setdppIdForUpdateSelected] = useState("");
  const handleChangeDppForUpdate = (selectedData) => {
    setdppIdForUpdateSelected(selectedData);
  };
  useEffect(() => {
    getDppIds(jwtToken);
  }, []);

  const [errorMsg, setErrorMsg] = useState("");

  const [allocateButtonName, setAllocateButtonName] = useState("Create");

  const onSubmit = async (values, { resetForm }) => {

    setAllocateButtonName("Please wait...");
    const payload = {
      cdBy: userId,
      dppId: dppIdSelected?.value,
      carbonFootprint: values.carbonFootprint,
      waterConsumption: values.waterConsumption,
      electricityConsumption: values.electricityConsumption,
      madeIn: values.madeIn,
      plant: values.Plant,
      prdOrder: values.ProductionOrder,
      prdCode: values.ProductionCode,
      fgQty: values.Quantity,
      operationCode: values.Operation,
      qualityYield: values.qualityYield,
      wasteGenerated: values.wasteGenerated,
      workCenter: values.WorkCenter,
      machineParameters: values.Parameters,
      rmIssueDate: values.ProductionDate,
      fgCompletionDate: values.CompletionDate,

      meltHeatNumber: values.meltHeatNumber,
      productionCastingBatch: values.productionCastingBatch,
      materialGrade: values.materialGrade,
      castingProcess: values.castingProcess,
      pouringCastingDate: values.pouringCastingDate,

      userId: userSelected?.value ? userSelected?.value : "",
    };

    let res = await createFG(payload, jwtToken);
    if (res.status) {
      setIsSuccessAllocateItem(true);
      // getOpenBinsByWarehouseAndZone(warehouseIdSelected?.value, zoneIdSelected);
      getFgOperation(dppIdSelectedForGlobalFilter?.value, jwtToken);
      formik.setErrors({});
      setActivityIdSelected("");
      setWarehouseIdSelected("");
      setZoneIdSelected("");
      setSectionIdSelected("");
      setRackIdSelected("");
      setLocationIdSelected("");
      setTimeout(() => {
        setAllocateButtonName("Create");
        handleCloseAllocateItemModal();
      }, 2250);
    }
    if (!res.status) {
      setErrorMsg(res?.data?.data?.msg);
      setAllocateButtonName("Create");

      // formik.setValues(initialValues);
      setIsErrorAllocateItem(true);
    }
    setSelectedItemCode("");
    setSelectedZoneName("");
    setSelectedBin("");
    // resetForm();
  };

  const [singleDataForDelete, setSingleDataForDelete] = useState({});
  const [openDeleteModal, setOpenDeleteModal] = useState(false);

  const handleOpenDeleteModal = (data) => {
    setOpenDeleteModal(true);
    setSingleDataForDelete(data);
  };

  const handleCloseDeleteModal = () => {
    setOpenDeleteModal(false);
  };

  const [isErrorDeleteAssembly, setIsErrorDeleteAssembly] = useState(false);
  const [errorMsgForDelete, setErrorMsgForDelete] = useState(false);
  const [isSuccessForAssembly, setIsSuccessForAssembly] = useState(false);

  useEffect(() => {
    if (isErrorDeleteAssembly) {
      setTimeout(() => {
        setIsErrorDeleteAssembly(false);
      }, 3000);
    }
  }, [isErrorDeleteAssembly]);
  useEffect(() => {
    if (isSuccessForAssembly) {
      setTimeout(() => {
        setIsSuccessForAssembly(false);
      }, 2000);
    }
  }, [isSuccessForAssembly]);

  const [deleteButtonName, setDeleteButtonName] = useState("Delete");

  const deleteTripNo = async () => {
    setDeleteButtonName("Please wait...");
    let fgOpId = singleDataForDelete.fgOpId;
    // let userId = singleDataForDelete.userId;

    let res = await deletefG(fgOpId);

    if (res.status) {
      getFgOperation(dppIdSelectedForGlobalFilter?.value, jwtToken);
      setTimeout(() => {
        handleCloseDeleteModal();
        setDeleteButtonName("Delete");
      }, 3000);
      setIsSuccessForAssembly(true);
    }

    if (!res.status) {
      setIsErrorDeleteAssembly(true);
      setErrorMsgForDelete(res?.data?.data?.msg);
      setDeleteButtonName("Delete");
    }
  };

  const formik = useFormik({
    initialValues,
    onSubmit,
    validationSchema,
  });

  const [isSuccessAddActivityMapping, setIsSuccessAddActivityMapping] =
    useState(false);
  const [isErrorAddActivityMapping, setIsErrorAddActivityMapping] =
    useState(false);

  useEffect(() => {
    if (isSuccessAddActivityMapping) {
      setTimeout(() => {
        setIsSuccessAddActivityMapping(false);
      }, 3000);
    }
  }, [isSuccessAddActivityMapping]);

  useEffect(() => {
    if (isErrorAddActivityMapping) {
      setTimeout(() => {
        setIsErrorAddActivityMapping(false);
      }, 3000);
    }
  }, [isErrorAddActivityMapping]);

  const [addActivityMappingModal, setAddActivityMappingModal] = useState(false);
  const handleAddActivityMappingModal = () => {
    setAddActivityMappingModal(!addActivityMappingModal);
    formikForAdd.setErrors({});
  };
  const handleCloseAddActivityMappingModal = () => {
    setAddActivityMappingModal(!addActivityMappingModal);
    formikForAdd.setErrors({});
  };

  const initialValueForAddActivityMapping = {
    bin: "",
  };

  const validationSchemaForAddActivityMapping = Yup.object({
    bin: Yup.string().required("Select the BIN"),
  });

  const onSubmitForAddActivityMapping = async (values, { resetForm }) => {
    const payload = {
      warehouseId: warehouseIdSelected?.value,
      itemId: ActivityMappingData.itemId,
      zoneId: ActivityMappingData.zoneId,
      locationId: selectedBinForAdd.value,
    };

    setSelectedBinForAdd("");
    resetForm();
  };

  const formikForAdd = useFormik({
    initialValues: initialValueForAddActivityMapping,
    validationSchema: validationSchemaForAddActivityMapping,
    onSubmit: onSubmitForAddActivityMapping,
  });

  const [isSuccessEditActivityMapping, setIsSuccessEditActivityMapping] =
    useState(false);
  const [isErrorEditActivityMapping, setIsErrorEditActivityMapping] =
    useState(false);

  useEffect(() => {
    if (isSuccessEditActivityMapping) {
      setTimeout(() => {
        setIsSuccessEditActivityMapping(false);
      }, 3000);
    }
  }, [isSuccessEditActivityMapping]);

  useEffect(() => {
    if (isErrorEditActivityMapping) {
      setTimeout(() => {
        setIsErrorEditActivityMapping(false);
      }, 3000);
    }
  }, [isErrorEditActivityMapping]);

  const [editActivityMappingModal, setEditActivityMappingModal] =
    useState(false);
  const handleEditActivityMappingModal = () => {
    setEditActivityMappingModal(!editActivityMappingModal);
    formikForEdit.setErrors({});
  };

  const handleCloseEditActivityMappingModal = () => {
    setEditActivityMappingModal(!editActivityMappingModal);
    formikForEdit.setErrors({});
  };
  const initialValueForEditActivityMapping = {
    bin: "",
  };

  const validationSchemaForEditActivityMapping = Yup.object({
    bin: Yup.string().required("Select the BIN"),
  });

  const onSubmitForEditActivityMapping = async (values, reset) => {
    const payload = {
      itemId: ActivityMappingData.itemId,
      warehouseId: warehouseIdSelected?.value,
      zoneId: ActivityMappingData.zoneId,
      locationId: selectedOpenBin?.value,
    };

    // let res = await editBinAllocation(payload, jwtToken);

    // if (res.status) {
    //   setIsSuccessEditActivityMapping(true);
    //   getFgOperation(warehouseIdSelected?.value, jwtToken);
    // }
    // if (!res.status) {
    //   setIsErrorEditActivityMapping(true);
    // }
    // setSelectedOpenBin("");
  };
  const formikForEdit = useFormik({
    initialValues: initialValueForEditActivityMapping,
    validationSchema: validationSchemaForEditActivityMapping,
    onSubmit: onSubmitForEditActivityMapping,
    enableReinitialize: true,
  });

  const [warehouseTypesSelectedForEdit, setWarehouseTypesSelectedForEdit] =
    useState("");
  const [itemCodeSelectedForEdit, setItemCodeSelectedForEdit] = useState("");
  const [acnTypeSelectedForEdit, setAcnTypeSelectedForEdit] = useState("");
  const [zoneSelectedForEdit, setZoneSelectedForEdit] = useState("");
  const [sectionSelectedForEdit, setSectionSelectedForEdit] = useState("");
  const [rackSelectedForEdit, setRackSelectedForEdit] = useState("");
  const [locationSelectedForEdit, setLocationSelectedForEdit] = useState("");

  const [singleFgDataForUpdate, setSingleFgDataForUpdate] = useState({});
  const [openUpdateModal, setOpenUpdateModal] = useState(false);

  const handleOpenUpdateModal = (singleData) => {
    setWarehouseTypesSelectedForEdit({
      label: singleData.warehouseCode,
      value: singleData.warehouseId,
    });
    setItemCodeSelectedForEdit({
      label: singleData.itemCode,
      value: singleData.itemId,
    });
    setAcnTypeSelectedForEdit({
      label: singleData.acnCode,
      value: singleData.acnId,
    });
    setZoneSelectedForEdit({
      label: singleData.zone,
      value: singleData.zoneId,
    });
    setSectionSelectedForEdit({
      label: singleData.section,
      value: singleData.sectionId,
    });
    setRackSelectedForEdit({
      label: singleData.rack,
      value: singleData.rackId,
    });
    setUserForUpdateSelected({
      label: singleData.name,
      value: singleData.userId,
    });
    setSingleFgDataForUpdate(singleData);
    setOpenUpdateModal(true);

    // getWarehousesByMovement(
    //   acnTypeSelectedForEdit?.value,

    //   jwtToken
    // );
  };

  const handleChangeWarehouseForEdit = (selectedOption) => {
    setWarehouseTypesSelectedForEdit(selectedOption);
    setZoneSelectedForEdit("");
  };
  const handleChangeAcnForEdit = (selectedOption) => {
    setAcnTypeSelectedForEdit(selectedOption);
  };
  const handleChangeZoneForEdit = (selectedOption) => {
    setZoneSelectedForEdit(selectedOption);
    setSectionSelectedForEdit("");
  };
  const handleChangeSectionForEdit = (selectedOption) => {
    setSectionSelectedForEdit(selectedOption);
    setRackSelectedForEdit("");
  };
  const handleChangeRackForEdit = (selectedOption) => {
    setRackSelectedForEdit(selectedOption);
    setLocationSelectedForEdit("");
  };
  const handleChangeLocationForEdit = (selectedOption) => {
    setLocationSelectedForEdit(selectedOption);
  };

  // cdBy:userId,
  //   dppId:dppIdSelected?.value,
  //   plant:values.Plant,
  //   prdCode:values.ProductionCode,
  //   fgQty:values.Quantity,
  //   operationCode:values.Operation,
  //   workCenter:values.WorkCenter,
  //   machineParameters:values.Parameters,
  //   rmIssueDate:values.ProductionDate,
  //   fgCompletionDate:values.CompletionDate,
  //   userId:userSelected?.value?userSelected?.value:""

  const initialValueForUpdate = {
    DPPID: singleFgDataForUpdate.productCode,
    Plant: singleFgDataForUpdate.plant,
    ProductionCode: singleFgDataForUpdate.prdCode,
    ProductionOrder: singleFgDataForUpdate.prdOrder,
    Quantity: singleFgDataForUpdate.fgQty,
    Operation: singleFgDataForUpdate.operationCode,

    carbonFootprint: singleFgDataForUpdate.carbonFootprint,
    waterConsumption: singleFgDataForUpdate.waterConsumption,
    WorkCenter: singleFgDataForUpdate.workCenter,
    electricityConsumption: singleFgDataForUpdate.electricityConsumption,
    madeIn: singleFgDataForUpdate.madeIn,
    wasteGenerated: singleFgDataForUpdate.wasteGenerated,
    qualityYield: singleFgDataForUpdate.qualityYield,
    Parameters: singleFgDataForUpdate.machineParameters,

    meltHeatNumber: singleFgDataForUpdate.meltHeatNumber,
    productionCastingBatch: singleFgDataForUpdate.productionCastingBatch,
    materialGrade: singleFgDataForUpdate.materialGrade,
    castingProcess: singleFgDataForUpdate.castingProcess,

    pouringCastingDate: singleFgDataForUpdate.pouringCastingDate
      ? (() => {
        const parts = singleFgDataForUpdate.pouringCastingDate.split("/");
        if (parts.length === 3) {
          const [month, day, year] = parts;
          return `${year}-${month}-${day}`;
        }
        return singleFgDataForUpdate.pouringCastingDate;
      })()
      : "",

    ProductionDate: singleFgDataForUpdate.rmIssueDate
      ? (() => {
        const [month, day, year] = singleFgDataForUpdate.rmIssueDate.split("/");
        return `${year}-${month}-${day}`;
      })()
      : "",

    CompletionDate: singleFgDataForUpdate.fgCompletionDate
      ? (() => {
        const [month, day, year] = singleFgDataForUpdate.fgCompletionDate.split("/");
        return `${year}-${month}-${day}`;
      })()
      : "",


    // QualityScore: singleFgDataForUpdate.qualityScore,
    // userId: singleFgDataForUpdate.userId,
  };

  const handleCloseModal = (event, reason) => {
    if (reason === "backdropClick")
      return;
    // setUserForUpdateSelected("")
    setOpenUpdateModal(false);
    formikForUpdate.setErrors({});
    formikForUpdate.setValues(initialValueForUpdate);
  };
  const [isErrorForUpdate, setIsErrorForUpdate] = useState(false);
  const [isSuccessForUpdate, setIsSuccessForUpdate] = useState(false);
  const [errorMsgForUpdate, setErrorMsgForUpdate] = useState("");

  useEffect(() => {
    if (isErrorForUpdate) {
      setTimeout(() => {
        setIsErrorForUpdate(false);
      }, 3000);
    }
  }, [isErrorForUpdate]);

  useEffect(() => {
    if (isSuccessForUpdate) {
      setTimeout(() => {
        setIsSuccessForUpdate(false);
      }, 3000);
    }
  }, [isSuccessForUpdate]);

  const [editButtonName, setEditButtonName] = useState("Update");

  const onSubmitForUpdate = async (values) => {
    setEditButtonName("Please wait...");
    let payload = {
      udBy: userId,
      carbonFootprint: String(values.carbonFootprint ?? ""),
      waterConsumption: String(values.waterConsumption ?? ""),
      madeIn: String(values.madeIn ?? ""),
      electricityConsumption: String(values.electricityConsumption ?? ""),
      dppId: singleFgDataForUpdate?.dppId,
      plant: values.Plant,
      fgOpId: singleFgDataForUpdate.fgOpId,
      prdCode: values.ProductionCode,
      prdOrder: values.ProductionOrder,
      fgQty: values.Quantity,
      operationCode: values.Operation,
      workCenter: values.WorkCenter,
      //  qualityYield: values.qualityYield,
      qualityYield: values.qualityYield.toString(),

      wasteGenerated: values.wasteGenerated.toString(),

      machineParameters: values.Parameters,
      rmIssueDate: values.ProductionDate,
      fgCompletionDate: values.CompletionDate,
      userId: userForUpdateSelected?.value,

      meltHeatNumber: String(values.meltHeatNumber ?? ""),
      productionCastingBatch: String(values.productionCastingBatch ?? ""),
      materialGrade: String(values.materialGrade ?? ""),
      castingProcess: String(values.castingProcess ?? ""),
      pouringCastingDate: values.pouringCastingDate,
    };
    let res = await editFg(payload, jwtToken);
    if (res.status) {
      setIsSuccessForUpdate(true);
      getFgOperation(dppIdSelectedForGlobalFilter?.value, jwtToken);
      setTimeout(() => {
        handleCloseModal();
        setEditButtonName("Update");
      }, 3000);
    }
    if (!res.status) {
      setIsErrorForUpdate(true);
      setErrorMsgForUpdate(res?.data?.data?.msg);
      setEditButtonName("Update");
    }
  };

  const formikForUpdate = useFormik({
    initialValues: initialValueForUpdate,
    onSubmit: onSubmitForUpdate,
    // validationSchema: validationSchemaForAssembly,
    enableReinitialize: true,
  });
  const [isErrorDeleteActivityMapping, setIsErrorDeleteActivityMapping] =
    useState(false);
  useEffect(() => {
    if (isErrorDeleteActivityMapping) {
      setTimeout(() => {
        setIsErrorDeleteActivityMapping(false);
      }, 3000);
    }
  }, [isErrorDeleteActivityMapping]);

  const [openDeleteActivityMappingModal, setOpenDeleteActivityMappingModal] =
    useState(false);

  const handleOpenDeleteActivityMappingModal = (data = {}) => {
    setActivityMappingData(data);
    setOpenDeleteActivityMappingModal(true);
  };

  const handleCloseDeleteActivityMappingModal = () => {
    setOpenDeleteActivityMappingModal(false);
  };

  const [deleteErrorMsg, setDeleteErrorMsg] = useState("");
  // const [editButtonName, setEditButtonName] = useState("Submit");

  const onClickDeleteActivityMapping = async () => {
    // let res = await removeBinAllocation(
    //   warehouseIdSelected?.value,
    //   ActivityMappingData.itemId,
    //   ActivityMappingData.zoneId,
    //   ActivityMappingData.locationId,
    //   jwtToken
    // );
    // if (res.status) {
    //   getFgOperation(warehouseIdSelected?.value, jwtToken);
    //   setOpenDeleteActivityMappingModal(false);
    // }
    // if (!res.status) {
    //   setDeleteErrorMsg(res.data.response.data.msg);
    //   setIsErrorDeleteActivityMapping(true);
    // }
  };

  const DataUploadSuccessNotification = () =>
    toast.success("Data Uploaded Successfully", {
      position: "top-center",
      autoClose: 2000,
    });

  const DataUploadFailureNotification = (data) =>
    toast.error(data, {
      position: "top-center",
      autoClose: 2000,
    });

  const [uploadCsvFilter, setUploadCsvFilter] = useState(false);
  const data = getRelationLocationReducer.locations?.data || [];
  const uploadCsvFilterHandler = () => {
    setUploadCsvFilter(!uploadCsvFilter);
  };
  const [uploadCsvData, setUploadCsvData] = useState({});

  const uploadCsvHandler = async () => {
    if (!uploadCsvData) {
      toast.error("Please select a CSV file first!");
      return;
    }

    let formData = new FormData();
    formData.append("file", uploadCsvData);

    try {
      let res = await uploadForProduction(formData, jwtToken);

      if (res?.status === true || res?.data?.status === true) {
        getFgOperation(dppIdSelectedForGlobalFilter?.value, jwtToken);
        setUploadCsvFilter(false);
      }

      showUploadNotification(res);
    } catch (error) {
      showUploadNotification(error);
    }
  };


  const showUploadNotification = (res) => {
    const payload = res?.response?.data || res?.data?.data || res?.data || res || {};

    const isSuccess = payload.status === true;
    const msg = payload.msg;
    const description = payload.description;

    const counts = {
      success: payload.successCount,
      error: payload.errorCount,
      duplicate: payload.duplicateCount
    };

    const toastOptions = {
      position: "top-center",
      autoClose: 5000,
      closeOnClick: false,
      draggable: true,
    };

    if (isSuccess) {
      toast.success(
        <CustomToastContent msg={msg} description={description} counts={counts} isSuccess={true} />,
        toastOptions
      );
    } else {
      toast.error(
        <CustomToastContent msg={msg} description={description} counts={counts} isSuccess={false} />,
        toastOptions
      );
    }
  };

  const subModuleId = "3a6c5d90-c26f-45c5-9294-3dd13df1b2d5";
  let dynamicColumnDetails = cookies.get("dynamic-column-data");
  let hiddenColumsDetails = cookies.get("hidden-column-data");
  useEffect(() => {
    getDynamicColumn(userId, subModuleId, jwtToken);
  }, [userId, subModuleId]);
  const [loadingForDynamicColumn, setLoadingForDynamicColumn] = useState(false);
  useEffect(() => {
    let data = getDynamicColumnReducer.dynamicColumn.data
      ? getDynamicColumnReducer.dynamicColumn.data
      : [];

    setDynamicColumnData(data);
    cookies.set("hidden-column-data", JSON.stringify(data?.notVisibleFields), {
      path: "/",
    });

    setTimeout(() => {
      setLoadingForDynamicColumn(true);
    }, 1000);
  }, [getDynamicColumnReducer, loading]);

  const [openCreateColumnReorderModal, setOpenCreateColumnReorderModal] =
    useState(false);

  const handleOpenCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(true);
  };

  const handleCloseCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(false);
  };

  const [dynamicColumnData, setDynamicColumnData] = useState("");
  const [isErrorColumnReorder, setIsErrorColumnReorder] = useState(false);
  const [isSuccessColumnReorder, setIsSuccessColumnReorder] = useState(false);

  useEffect(() => {
    if (isErrorColumnReorder) {
      setTimeout(() => {
        setIsErrorColumnReorder(false);
      }, 3000);
    }
  }, [isErrorColumnReorder]);

  useEffect(() => {
    if (isSuccessColumnReorder) {
      setTimeout(() => {
        setIsSuccessColumnReorder(false);
      }, 3000);
    }
  }, [isSuccessColumnReorder]);

  const [isErrorMsgForColumnReorder, setIsErrorMsgForColumnReorder] =
    useState(false);

  const handleDynamicColumn = async () => {
    let res = await createDynamicColumn(dynamicColumnDetails, jwtToken);
    if (res.status) {
      setIsSuccessColumnReorder(true);
      getDynamicColumn(userId, subModuleId, jwtToken);

      getFgOperation(dppIdSelectedForGlobalFilter?.value, jwtToken);
      setTimeout(() => {
        handleCloseCreateColumnReorderModal();
        // window.location.reload();
      }, 2250);
    }
    if (!res.status) {
      setIsErrorColumnReorder(true);
      setIsErrorMsgForColumnReorder(res?.data?.data?.msg);
    }
  };



  const [vendorsListForPlannerSelected, setVendorsListForPlannerSelected] =
    useState("");


  //  useEffect(() => {
  //    getPoNumberByDppId(vendorsListForPlannerSelected?.value,dppIdSelectedForGlobalFilter?.value,jwtToken);
  //  }, [vendorsListForPlannerSelected,dppIdSelectedForGlobalFilter]);
  const [vendorsListForPlannerOptions, setVendorsListForPlannerOptions] =
    useState([]);

  useEffect(() => {
    let tempVendorsListForPlannerOptions = [];
    let data = getPOnumberReducer.PONumber.data
      ? getPOnumberReducer.PONumber.data
      : [];
    console.log("data", data)
    data.map((vendorsListForPlanner) => {
      tempVendorsListForPlannerOptions.push({
        label: vendorsListForPlanner.poNumber,
        value: vendorsListForPlanner.poNumber,
      });
    });
    setVendorsListForPlannerOptions(tempVendorsListForPlannerOptions);
  }, [getPOnumberReducer]);

  const handleChangeVendorsListForPlanner = (selectedOption) => {
    setVendorsListForPlannerSelected(selectedOption);
    // setPartNoSelected("");
  };

  const DataUploadSuccessNotificationForPonumber = () =>
    toast.success("Po Number Generated Successfully", {
      position: "top-center",
      autoClose: 2000,
    });

  const DataUploadFailureNotificationPonumber = (data) =>
    toast.error(data, {
      position: "top-center",
      autoClose: 2000,
    });
  const [poInsertAttempted, setPoInsertAttempted] = useState(false);
  useEffect(() => {
    if (!poInsertAttempted) return;
    if (getPOnumberFGReducer.loading) return;

    const { status, error } = getPOnumberFGReducer;

    if (status === "success") {
      DataUploadSuccessNotificationForPonumber();

      if (dppIdSelectedForGlobalFilter?.value && jwtToken) {
        getFgOperation(
          dppIdSelectedForGlobalFilter.value,
          jwtToken
        );
      }

      setPoInsertAttempted(false); // 🔥 prevents duplicate toasts
    }

    if (status === "failure") {
      DataUploadFailureNotificationPonumber("PO Number was not generated");
      setPoInsertAttempted(false);
    }

  }, [
    poInsertAttempted,
    getPOnumberFGReducer.loading,
    getPOnumberFGReducer.status,
    getPOnumberFGReducer.error,
    dppIdSelectedForGlobalFilter?.value,
    jwtToken,
  ]);



  const handleInsertPoNumber = async () => {
    try {
      setPoInsertAttempted(true); // mark that we attempted insert
      await getInsertPoNumberProduction(
        vendorsListForPlannerSelected?.value,
        dppIdSelectedForGlobalFilter?.value,
        jwtToken
      );
    } catch (error) {
      DataUploadFailureNotificationPonumber(
        error?.response?.data?.message ||
        error?.message ||
        "Something went wrong"
      );
    }
  };


  useEffect(() => {
    getPoNumberByDppId(dppIdSelectedForGlobalFilter?.value, jwtToken);
  }, [dppIdSelectedForGlobalFilter]);



  return (
    // <DashboardLayout>
    //   <DashboardNavbar />
    <div>
      <MDBox pt={0} pb={0} mb={-2.5}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <MDBox
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              p={0}
              mb={-4.5}
              mt={-1}
            >
              <MDBox
                color="text"
                px={2}
                ml={-2}
                mb={4}
                display="flex"
                alignItems="center"
                gap={1.5}
              >
                {allocateAccess && (
                  // <Tooltip title="Allocate Location">
                  <CreateButton
                    tooltip="Add Production"
                    color="info"
                    variant="contained"
                    type="button"
                    iconOnly
                    onClick={() => {
                      handleAllocateItemModal();
                      getWarehouses(jwtToken);
                      getItemMaster(jwtToken);
                      getAcn(jwtToken);
                      getRelationLocation(jwtToken);
                    }}
                    style={{ borderRadius: "5px" }}
                    size="small"
                  >
                    <Icon>add</Icon>
                  </CreateButton>
                  // </Tooltip>
                )}

                {/* ✅ PO NUMBER DROPDOWN (LEFT OF GENERATE PO) */}
                <MDBox width="200px">
                  <Select
                    isClearable
                    placeholder="Work Order"
                    className="select-css-for-filter"
                    value={vendorsListForPlannerSelected}
                    options={vendorsListForPlannerOptions}
                    onChange={handleChangeVendorsListForPlanner}
                    autoComplete="off"
                  />
                </MDBox>

                {/* ✅ GENERATE PO BUTTON */}
                <Tooltip title="SYNC Data">
                  <IconButton
                    size="small"
                    onClick={handleInsertPoNumber}
                    sx={{
                      border: "1px solid",
                      borderColor: "success.main",
                      color: "success.main",
                      borderRadius: "6px",
                      "&:hover": {
                        backgroundColor: "success.main",
                        color: "#fff",
                      },
                    }}
                  >
                    <Icon>post_add</Icon>
                  </IconButton>
                </Tooltip>

                {/* DOWNLOAD FG LIST */}
                <CSVLink {...csvLink}>
                  <DownloadDataButton
                    tooltip="Download Production List"
                    variant="outlined"
                    color="error"
                    iconOnly
                  >
                    <Icon>download</Icon>
                  </DownloadDataButton>
                </CSVLink>

                {/* UPLOAD CSV */}
                <UploadButton
                  tooltip="Upload CSV"
                  variant="outlined"
                  color="info"
                  iconOnly
                  style={{ marginTop: "2px" }}
                  onClick={uploadCsvFilterHandler}
                >
                  <Icon>upload</Icon>
                </UploadButton>

                {/* DOWNLOAD TEMPLATE */}
                <CSVLink {...csvLink2}>
                  <DownloadButton
                    tooltip="Download Template"
                    variant="outlined"
                    color="error"
                    iconOnly
                  >
                    <Icon>download</Icon>
                  </DownloadButton>
                </CSVLink>
              </MDBox>
            </MDBox>


            {uploadCsvFilter && (
              <div style={{ marginLeft: "1", marginTop: "0.5rem" }}>
                <div>
                  <input
                    className="choose_file"
                    style={{
                      marginTop: "1.5rem",
                      marginLeft: "1.5rem",
                      // marginBottom: "-9rem",
                    }}
                    type="file"
                    accept=".csv"
                    onChange={(e) => {
                      setUploadCsvData(e.target.files[0]);
                    }}
                  />
                  <MDButton
                    disabled={
                      !uploadCsvData?.name || uploadCsvData?.type !== "text/csv"
                    }
                    variant="contained"
                    color="info"
                    style={{
                      marginLeft: { xs: "1.5rem", lg: "1" },
                      marginTop: "0rem",
                    }}
                    type="button"
                    onClick={uploadCsvHandler}
                  >
                    UPLOAD
                  </MDButton>
                </div>
                <div style={{ marginBottom: "-20px" }}>
                  <span
                    style={{
                      color: "red",
                      fontSize: "14px",
                      marginLeft: "30px",
                      fontStyle: "italic",
                    }}
                  >
                    <strong>*</strong> Please upload
                    <strong>".csv"</strong> file only
                  </span>
                </div>
              </div>
            )}
            <Modal
              open={openCreateColumnReorderModal}
              onClose={handleCloseCreateColumnReorderModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={styleForColumnReorder}>
                <MDTypography>Are you sure you want to submit?</MDTypography>
                <MDBox mt={2}>
                  <MDButton
                    style={{ width: "10rem", marginRight: "0.5rem" }}
                    color="info"
                    variant="outlined"
                    onClick={handleCloseCreateColumnReorderModal}
                  >
                    Cancel
                  </MDButton>
                  <MDButton
                    style={{ width: "10rem", marginLeft: "0.5rem" }}
                    color="success"
                    onClick={handleDynamicColumn}
                  // disabled={denyButtonName === "Please wait..."}
                  >
                    Submit
                  </MDButton>
                </MDBox>
                <MDBox mt={2}>
                  <Collapse in={isSuccessColumnReorder}>
                    <Alert
                      severity="success"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsSuccessColumnReorder(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      Data updated successfully!
                    </Alert>
                  </Collapse>
                  <Collapse in={isErrorColumnReorder}>
                    <Alert
                      severity="error"
                      action={
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          size="small"
                          onClick={() => {
                            setIsErrorColumnReorder(false);
                          }}
                        >
                          <CloseIcon fontSize="inherit" />
                        </IconButton>
                      }
                    >
                      {isErrorMsgForColumnReorder}
                    </Alert>
                  </Collapse>
                </MDBox>
              </MDCard>
            </Modal>

            <MDBox pt={0}>
              {/* {loadingForDynamicColumn && ( */}
              <DataTable
                table={{ columns, rows }}
                isSorted={true}
                tableSearch={true}
                entriesPerPage={{
                  defaultValue: 5,
                  entries: [5, 10, 15, 20, 25, 30],
                }}
                showTotalEntries={true}
                noEndBorder
                options={{ draggable: false }}
                // serverSidePagination={true}
                // paginationObj={paginationObj}
                pageNoValue={pageNo}
                rowsPerPageValue={rowsPerPage}
                pageNoProp={importPageNo}
                rowsPerPageProp={importRowsPerPage}
                searchProp={importSearch}
                loading={loading}
                hideColumns={hiddenColumsDetails}
                visibleColumns2={dynamicColumnData?.visibleFields}
                dynamicColumnData={dynamicColumnData}
                handleOpenCreateColumnReorderModal={
                  handleOpenCreateColumnReorderModal
                }
                subModuleId={subModuleId}
                userId={userId}
              />
              {/* )} */}
            </MDBox>
            <Modal
              open={openDeleteModal}
              onClose={handleCloseDeleteModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={deleteStyle}>
                <MDTypography>Are you sure you want to delete?</MDTypography>
                <MDBox mt={2}>
                  <MDButton
                    color="info"
                    variant="outlined"
                    onClick={handleCloseDeleteModal}
                  >
                    Cancel
                  </MDButton>
                  <MDButton
                    style={{ marginLeft: "0.5rem" }}
                    color="error"
                    onClick={deleteTripNo}
                    disabled={deleteButtonName === "Please wait..."}
                  >
                    {deleteButtonName}
                  </MDButton>
                  <MDBox mt={2}>
                    <Collapse in={isErrorDeleteAssembly}>
                      <Alert
                        severity="error"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsErrorDeleteAssembly(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        {errorMsgForDelete}
                      </Alert>
                    </Collapse>
                    <Collapse in={isSuccessForAssembly}>
                      <Alert
                        severity="success"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsSuccessForAssembly(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        Deleted Successfully
                      </Alert>
                    </Collapse>
                  </MDBox>
                </MDBox>
              </MDCard>
            </Modal>
            <Modal
              open={openUpdateModal}
              onClose={handleCloseModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={styleForEdit}>
                <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                  <MDTypography variant="h4" fontWeight="medium" flexGrow={1}>
                    Update
                  </MDTypography>
                  <MDBox>
                    <Tooltip title="Close">
                      <IconButton
                        aria-label="close"
                        color="inherit"
                        onClick={handleCloseModal}
                        style={{
                          background: "whitesmoke",
                          color: "black",
                          borderRadius: 5,
                          marginRight: "10px",
                          marginTop: "4px",
                        }}
                      >
                        <CloseIcon />
                      </IconButton>
                    </Tooltip>
                  </MDBox>
                </MDBox>
                <hr style={{ marginTop: "0.5rem", marginBottom: "0rem" }} />

                <MDBox pt={1} pb={3} px={3}>
                  <MDBox
                    component="form"
                    role="form"
                    onSubmit={formikForUpdate.handleSubmit}
                  >
                    <MDBox>
                      <Grid container spacing={1}>
                        <Grid item xs={12} lg={4}>
                          <MDBox>
                            <MDTypography variant="h6">DPP Code</MDTypography>
                            <MDInput
                              type="text"
                              name="DPPID"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.DPPID}
                              error={
                                formikForUpdate.touched.DPPID &&
                                formikForUpdate.errors.DPPID &&
                                true
                              }
                              disabled={true}
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.DPPID &&
                              formikForUpdate.errors.DPPID && (
                                <TextError msg={formikForUpdate.errors.DPPID} />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={4}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">Plant</MDTypography>
                            <MDInput
                              type="text"
                              name="Plant"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.Plant}
                              error={
                                formikForUpdate.touched.Plant &&
                                formikForUpdate.errors.Plant &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.Plant &&
                              formikForUpdate.errors.Plant && (
                                <TextError msg={formikForUpdate.errors.Plant} />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={4}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">
                              Production Order
                            </MDTypography>
                            <MDInput
                              type="text"
                              name="ProductionOrder"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.ProductionOrder}
                              error={
                                formikForUpdate.touched.ProductionOrder &&
                                formikForUpdate.errors.ProductionOrder &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.ProductionOrder &&
                              formikForUpdate.errors.ProductionOrder && (
                                <TextError
                                  msg={formikForUpdate.errors.ProductionOrder}
                                />
                              )}
                          </MDBox>
                        </Grid>

                        <Grid item xs={12} lg={4} mt={1}>
                          <MDBox>
                            <MDTypography variant="h6">Melt / Heat Number</MDTypography>
                            <MDInput
                              type="text"
                              name="meltHeatNumber"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.meltHeatNumber}
                              error={formikForUpdate.touched.meltHeatNumber && Boolean(formikForUpdate.errors.meltHeatNumber)}
                              inputProps={{ style: { height: "10px" } }}
                            />
                            {formikForUpdate.touched.meltHeatNumber && formikForUpdate.errors.meltHeatNumber && (
                              <TextError msg={formikForUpdate.errors.meltHeatNumber} />
                            )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={4} mt={1}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">Quantity</MDTypography>
                            <MDInput
                              type="number"
                              name="Quantity"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.Quantity}
                              error={
                                formikForUpdate.touched.Quantity &&
                                formikForUpdate.errors.Quantity &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.Quantity &&
                              formikForUpdate.errors.Quantity && (
                                <TextError
                                  msg={formikForUpdate.errors.Quantity}
                                />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={4} mt={1}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">Operation</MDTypography>
                            <MDInput
                              type="text"
                              name="Operation"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.Operation}
                              error={
                                formikForUpdate.touched.Operation &&
                                formikForUpdate.errors.Operation &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.Operation &&
                              formikForUpdate.errors.Operation && (
                                <TextError
                                  msg={formikForUpdate.errors.Operation}
                                />
                              )}
                          </MDBox>
                        </Grid>

                        <Grid item xs={12} lg={4} mt={1}>
                          <MDBox >
                            <MDTypography variant="h6">
                              Work Center
                            </MDTypography>
                            <MDInput
                              type="text"
                              name="WorkCenter"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.WorkCenter}
                              error={
                                formikForUpdate.touched.WorkCenter &&
                                formikForUpdate.errors.WorkCenter &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.WorkCenter &&
                              formikForUpdate.errors.WorkCenter && (
                                <TextError
                                  msg={formikForUpdate.errors.WorkCenter}
                                />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={8} mt={1}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">Parameters</MDTypography>
                            <MDInput
                              type="text"
                              name="Parameters"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.Parameters}
                              error={
                                formikForUpdate.touched.Parameters &&
                                formikForUpdate.errors.Parameters &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.Parameters &&
                              formikForUpdate.errors.Parameters && (
                                <TextError
                                  msg={formikForUpdate.errors.Parameters}
                                />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={4} mt={1}>
                          <MDBox >
                            <MDTypography variant="h6">
                              Production Date
                            </MDTypography>
                            <MDInput
                              type="date"
                              name="ProductionDate"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.ProductionDate}
                              error={
                                formikForUpdate.touched.ProductionDate &&
                                formikForUpdate.errors.ProductionDate &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.ProductionDate &&
                              formikForUpdate.errors.ProductionDate && (
                                <TextError
                                  msg={formikForUpdate.errors.ProductionDate}
                                />
                              )}
                          </MDBox>
                        </Grid>

                        <Grid item xs={12} lg={4} mt={1}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">Pouring / Casting Date</MDTypography>
                            <MDInput
                              type="date"
                              name="pouringCastingDate"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.pouringCastingDate}
                              error={formikForUpdate.touched.pouringCastingDate && Boolean(formikForUpdate.errors.pouringCastingDate)}
                              inputProps={{ style: { height: "10px" } }}
                            />
                            {formikForUpdate.touched.pouringCastingDate && formikForUpdate.errors.pouringCastingDate && (
                              <TextError msg={formikForUpdate.errors.pouringCastingDate} />
                            )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={4} mt={1}>
                          <MDBox ml={1} >
                            <MDTypography variant="h6">
                              Production Batch
                            </MDTypography>
                            <MDInput
                              type="text"
                              name="ProductionCode"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.ProductionCode}
                              error={
                                formikForUpdate.touched.ProductionCode &&
                                formikForUpdate.errors.ProductionCode &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.ProductionCode &&
                              formikForUpdate.errors.ProductionCode && (
                                <TextError
                                  msg={formikForUpdate.errors.ProductionCode}
                                />
                              )}
                          </MDBox>
                        </Grid>


                        <Grid item xs={12} lg={4} mt={1}>
                          <MDBox>
                            <MDTypography variant="h6">Material Grade</MDTypography>
                            <MDInput
                              type="text"
                              name="materialGrade"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.materialGrade}
                              error={formikForUpdate.touched.materialGrade && Boolean(formikForUpdate.errors.materialGrade)}
                              inputProps={{ style: { height: "10px" } }}
                            />
                            {formikForUpdate.touched.materialGrade && formikForUpdate.errors.materialGrade && (
                              <TextError msg={formikForUpdate.errors.materialGrade} />
                            )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={4} mt={1}>
                          <MDBox ml={1}>
                            <MDTypography
                              variant="h6"
                              style={{ fontWeight: "500" }}
                            >
                              {" "}
                              User{" "}
                            </MDTypography>

                            <Select
                              // isDisabled={activityIdSelected ? false : true}
                              isClearable
                              className="select-css"
                              maxMenuHeight={300}
                              menuPlacement="top"
                              menuPosition="absolute"
                              placeholder="Choose one..."
                              name="User"
                              onBlur={() => {
                                formikForUpdate.handleBlur({
                                  target: { name: "User" },
                                });
                              }}
                              value={userForUpdateSelected}
                              options={userOptions}
                              onChange={(selectedOption) => {
                                handleChangeUserForUpdate(selectedOption);
                                // getZonesByWarehouse(selectedOption?.value);
                                formikForUpdate.setFieldValue("User", selectedOption);
                              }}
                            />
                            {formikForUpdate.touched.User && formikForUpdate.errors.User && (
                              <TextError msg={formikForUpdate.errors.User} />
                            )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={4} mt={1}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">
                              Completion Date
                            </MDTypography>
                            <MDInput
                              type="date"
                              name="CompletionDate"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.CompletionDate}
                              error={
                                formikForUpdate.touched.CompletionDate &&
                                formikForUpdate.errors.CompletionDate &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },
                                maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.CompletionDate &&
                              formikForUpdate.errors.CompletionDate && (
                                <TextError
                                  msg={formikForUpdate.errors.CompletionDate}
                                />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={4} mt={1}>
                          <MDBox >
                            <MDTypography variant="h6">
                              Carbon Footprint(kg CO₂)
                            </MDTypography>
                            <MDInput
                              type="text"
                              name="carbonFootprint"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.carbonFootprint}
                              error={
                                formikForUpdate.touched.carbonFootprint &&
                                formikForUpdate.errors.carbonFootprint &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },

                                // maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.carbonFootprint &&
                              formikForUpdate.errors.carbonFootprint && (
                                <TextError msg={formikForUpdate.errors.carbonFootprint} />
                              )}
                          </MDBox>
                        </Grid>

                        <Grid item xs={12} lg={4} mt={1}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">
                              Electricity Consumption(kWh)
                            </MDTypography>
                            <MDInput
                              type="text"
                              name="electricityConsumption"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.electricityConsumption}
                              error={
                                formikForUpdate.touched.electricityConsumption &&
                                formikForUpdate.errors.electricityConsumption &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },

                                // maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.electricityConsumption &&
                              formikForUpdate.errors.electricityConsumption && (
                                <TextError msg={formikForUpdate.errors.electricityConsumption} />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={4} mt={1}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">
                              Water Consumption(L)
                            </MDTypography>
                            <MDInput
                              type="text"
                              name="waterConsumption"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.waterConsumption}
                              error={
                                formikForUpdate.touched.waterConsumption &&
                                formikForUpdate.errors.waterConsumption &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },

                                // maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.waterConsumption &&
                              formikForUpdate.errors.waterConsumption && (
                                <TextError msg={formikForUpdate.errors.waterConsumption} />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={4} mt={1}>
                          <MDBox>
                            <MDTypography variant="h6">
                              Made In
                            </MDTypography>
                            <MDInput
                              type="text"
                              name="madeIn"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.madeIn}
                              error={
                                formikForUpdate.touched.madeIn &&
                                formikForUpdate.errors.madeIn &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },

                                // maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.madeIn &&
                              formikForUpdate.errors.madeIn && (
                                <TextError msg={formikForUpdate.errors.madeIn} />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={4} mt={1}>
                          <MDBox ml={1} >
                            <MDTypography variant="h6">
                              Quality Yield
                            </MDTypography>
                            <MDInput
                              type="text"
                              name="qualityYield"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.qualityYield}
                              error={
                                formikForUpdate.touched.qualityYield &&
                                formikForUpdate.errors.qualityYield &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },

                                // maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.qualityYield &&
                              formikForUpdate.errors.qualityYield && (
                                <TextError msg={formikForUpdate.errors.qualityYield} />
                              )}
                          </MDBox>
                        </Grid>
                        <Grid item xs={12} lg={4} mt={1}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">
                              Waste Generated
                            </MDTypography>
                            <MDInput
                              type="text"
                              name="wasteGenerated"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.wasteGenerated}
                              error={
                                formikForUpdate.touched.wasteGenerated &&
                                formikForUpdate.errors.wasteGenerated &&
                                true
                              }
                              inputProps={{
                                style: {
                                  height: "10px",
                                },

                                // maxLength: 45,
                              }}
                            />
                            {formikForUpdate.touched.wasteGenerated &&
                              formikForUpdate.errors.wasteGenerated && (
                                <TextError msg={formikForUpdate.errors.wasteGenerated} />
                              )}
                          </MDBox>
                        </Grid>




                        <Grid item xs={12} lg={4} mt={1}>
                          <MDBox>
                            <MDTypography variant="h6">Production Batch / Casting</MDTypography>
                            <MDInput
                              type="text"
                              name="productionCastingBatch"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.productionCastingBatch}
                              error={formikForUpdate.touched.productionCastingBatch && Boolean(formikForUpdate.errors.productionCastingBatch)}
                              inputProps={{ style: { height: "10px" } }}
                            />
                            {formikForUpdate.touched.productionCastingBatch && formikForUpdate.errors.productionCastingBatch && (
                              <TextError msg={formikForUpdate.errors.productionCastingBatch} />
                            )}
                          </MDBox>
                        </Grid>




                        <Grid item xs={12} lg={4} mt={1}>
                          <MDBox ml={1}>
                            <MDTypography variant="h6">Casting Process</MDTypography>
                            <MDInput
                              type="text"
                              name="castingProcess"
                              fullWidth
                              autoComplete="off"
                              onBlur={formikForUpdate.handleBlur}
                              onChange={formikForUpdate.handleChange}
                              value={formikForUpdate.values.castingProcess}
                              error={formikForUpdate.touched.castingProcess && Boolean(formikForUpdate.errors.castingProcess)}
                              inputProps={{ style: { height: "10px" } }}
                            />
                            {formikForUpdate.touched.castingProcess && formikForUpdate.errors.castingProcess && (
                              <TextError msg={formikForUpdate.errors.castingProcess} />
                            )}
                          </MDBox>
                        </Grid>



                        {/* <Grid item xs={12} lg={4}>
                          <MDBox mb={2} ml={1} >
                            <MDTypography
                              variant="h6"
                              style={{ fontWeight: 500 }}
                            >
                              Status
                            </MDTypography>
                            <Select
                              isClearable
                              className="select-css"
                              maxMenuHeight={70}
                              placeholder="Select..."
                              name="location"
                              options={level4Options}
                              value={locationSelectedForEdit} // Ensure this matches the shape of options
                              onChange={(selectedOption) => {
                                handleChangeLocationForEdit(selectedOption);
                                formikForUpdate.setFieldValue(
                                  "location",
                                  selectedOption
                                );
                              }}
                            />
                            {formikForUpdate.touched.location &&
                              formikForUpdate.errors.location && (
                                <TextError
                                  msg={formikForUpdate.errors.location}
                                />
                              )}
                          </MDBox>
                        </Grid> */}


                        <Grid item xs={12} mt={2}>
                          <MDBox >
                            <Collapse in={isErrorForUpdate}>
                              <Alert
                                severity="error"
                                action={
                                  <IconButton
                                    aria-label="close"
                                    color="inherit"
                                    size="small"
                                    onClick={() => {
                                      setIsErrorForUpdate(false);
                                    }}
                                  >
                                    <CloseIcon fontSize="inherit" />
                                  </IconButton>
                                }
                              >
                                {errorMsgForUpdate}
                              </Alert>
                            </Collapse>
                            <Collapse in={isSuccessForUpdate}>
                              <Alert
                                severity="success"
                                action={
                                  <IconButton
                                    aria-label="close"
                                    color="inherit"
                                    size="small"
                                    onClick={() => {
                                      setIsSuccessForUpdate(false);
                                    }}
                                  >
                                    <CloseIcon fontSize="inherit" />
                                  </IconButton>
                                }
                              >
                                Updated successfully
                              </Alert>
                            </Collapse>
                          </MDBox>
                        </Grid>

                        <MDButton

                          color="info"
                          fullWidth
                          type="submit"
                          disabled={editButtonName === "Please wait..."}
                        >
                          {editButtonName}
                        </MDButton>
                      </Grid>
                    </MDBox>
                  </MDBox>
                </MDBox>
              </MDCard>
            </Modal>
            <Modal
              open={allocateItemModal}
              onClose={handleCloseAllocateItemModal}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <MDCard sx={style}>
                <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                  <MDTypography variant="h5" fontWeight="medium" flexGrow={1}>
                    Create Production Record
                  </MDTypography>
                  <MDBox>
                    <span>
                      <Tooltip title="Close">
                        <IconButton
                          style={{
                            background: "whitesmoke",
                            color: "black",
                            borderRadius: 5,
                            // marginLeft: "-55px",
                            marginRight: "10px",
                            marginTop: "4px",
                          }}
                          aria-label="close"
                          color="inherit"
                          onClick={handleCloseAllocateItemModal}
                        >
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    </span>
                  </MDBox>
                </MDBox>
                <hr style={{ marginTop: "0.5rem", marginBottom: "0rem" }} />

                <MDBox pt={1} pb={3} px={3}>
                  <MDBox
                    component="form"
                    role="form"
                    onSubmit={formik.handleSubmit}
                  >
                    <Grid container>
                      <Grid item xs={12} lg={4}>
                        <MDBox>
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: "500" }}
                          >
                            {" "}
                            DPP Code{" "}
                          </MDTypography>

                          <Select
                            // isDisabled={activityIdSelected ? false : true}
                            isClearable
                            className="select-css"
                            maxMenuHeight={200}
                            placeholder="Choose one..."
                            name="DPPID"
                            onBlur={() => {
                              formik.handleBlur({
                                target: { name: "DPPID" },
                              });
                            }}
                            value={dppIdSelected}
                            options={dppOptions}
                            onChange={(selectedOption) => {
                              handleChangeDpp(selectedOption);
                              // getZonesByWarehouse(selectedOption?.value);
                              formik.setFieldValue("DPPID", selectedOption);
                            }}
                          />
                          {formik.touched.DPPID && formik.errors.DPPID && (
                            <TextError msg={formik.errors.DPPID} />
                          )}
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={4}>
                        <MDBox ml={1}>
                          <MDTypography variant="h6">Plant</MDTypography>
                          <MDInput
                            type="text"
                            name="Plant"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.Plant}
                            error={
                              formik.touched.Plant &&
                              formik.errors.Plant &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },
                              maxLength: 45,
                            }}
                          />
                          {formik.touched.Plant && formik.errors.Plant && (
                            <TextError msg={formik.errors.Plant} />
                          )}
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={4}>
                        <MDBox ml={1}>
                          <MDTypography variant="h6">
                            Production Order
                          </MDTypography>
                          <MDInput
                            type="text"
                            name="ProductionOrder"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.ProductionOrder}
                            error={
                              formik.touched.ProductionOrder &&
                              formik.errors.ProductionOrder &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },
                              maxLength: 45,
                            }}
                          />
                          {formik.touched.ProductionOrder &&
                            formik.errors.ProductionOrder && (
                              <TextError msg={formik.errors.ProductionOrder} />
                            )}
                        </MDBox>
                      </Grid>

                      {/* Melt / Heat Number */}
                      <Grid item xs={12} lg={4} mt={2}>
                        <MDBox >
                          <MDTypography variant="h6" style={{ fontWeight: "500" }}>Melt / Heat Number</MDTypography>
                          <MDInput
                            type="text"
                            name="meltHeatNumber"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.meltHeatNumber}
                            error={formik.touched.meltHeatNumber && Boolean(formik.errors.meltHeatNumber)}
                            inputProps={{ style: { height: "10px" } }}
                          />
                          {formik.touched.meltHeatNumber && formik.errors.meltHeatNumber && (
                            <TextError msg={formik.errors.meltHeatNumber} />
                          )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={4} mt={2}>
                        <MDBox ml={1}>
                          <MDTypography variant="h6">Quantity</MDTypography>
                          <MDInput
                            type="number"
                            name="Quantity"

                            // placeholder="Enter number"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.Quantity}
                            error={
                              formik.touched.Quantity &&
                              formik.errors.Quantity &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },
                              maxLength: 45,
                            }}
                          />
                          {formik.touched.Quantity &&
                            formik.errors.Quantity && (
                              <TextError msg={formik.errors.Quantity} />
                            )}
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={4} mt={2}>
                        <MDBox ml={1}>
                          <MDTypography variant="h6">Operation</MDTypography>
                          <MDInput
                            type="text"
                            name="Operation"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.Operation}
                            error={
                              formik.touched.Operation &&
                              formik.errors.Operation &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },
                              maxLength: 45,
                            }}
                          />
                          {formik.touched.Operation &&
                            formik.errors.Operation && (
                              <TextError msg={formik.errors.Operation} />
                            )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={4} mt={2}>
                        <MDBox>
                          <MDTypography variant="h6">Work Center</MDTypography>
                          <MDInput
                            type="text"
                            name="WorkCenter"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.WorkCenter}
                            error={
                              formik.touched.WorkCenter &&
                              formik.errors.WorkCenter &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },

                              // maxLength: 45,
                            }}
                          />
                          {formik.touched.WorkCenter &&
                            formik.errors.WorkCenter && (
                              <TextError msg={formik.errors.WorkCenter} />
                            )}
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={8} mt={2}>
                        <MDBox ml={1}>
                          <MDTypography variant="h6">Parameters</MDTypography>
                          <MDInput
                            type="text"
                            name="Parameters"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.Parameters}
                            error={
                              formik.touched.Parameters &&
                              formik.errors.Parameters &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },

                              // maxLength: 45,
                            }}
                          />
                          {formik.touched.Parameters &&
                            formik.errors.Parameters && (
                              <TextError msg={formik.errors.Parameters} />
                            )}
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={4} mt={2}>
                        <MDBox >
                          <MDTypography variant="h6">
                            Production Date
                          </MDTypography>
                          <MDInput
                            type="date"
                            name="ProductionDate"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.ProductionDate}
                            error={
                              formik.touched.ProductionDate &&
                              formik.errors.ProductionDate &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },

                              // maxLength: 45,
                            }}
                          />
                          {formik.touched.ProductionDate &&
                            formik.errors.ProductionDate && (
                              <TextError msg={formik.errors.ProductionDate} />
                            )}
                        </MDBox>
                      </Grid>

                      {/* Pouring / Casting Date */}
                      <Grid item xs={12} lg={4} mt={2}>
                        <MDBox ml={1}>
                          <MDTypography variant="h6" style={{ fontWeight: "500" }}>Pouring / Casting Date</MDTypography>
                          <MDInput
                            type="date"
                            name="pouringCastingDate"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.pouringCastingDate}
                            error={formik.touched.pouringCastingDate && Boolean(formik.errors.pouringCastingDate)}
                            inputProps={{ style: { height: "10px" } }}
                          />
                          {formik.touched.pouringCastingDate && formik.errors.pouringCastingDate && (
                            <TextError msg={formik.errors.pouringCastingDate} />
                          )}
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={4} mt={2}>
                        <MDBox ml={1}>
                          <MDTypography variant="h6">
                            Production Batch
                          </MDTypography>
                          <MDInput
                            type="text"
                            name="ProductionCode"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.ProductionCode}
                            error={
                              formik.touched.ProductionCode &&
                              formik.errors.ProductionCode &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },

                              // maxLength: 45,
                            }}
                          />
                          {formik.touched.ProductionCode &&
                            formik.errors.ProductionCode && (
                              <TextError msg={formik.errors.ProductionCode} />
                            )}
                        </MDBox>
                      </Grid>

                      {/* Material Grade */}
                      <Grid item xs={12} lg={4} mt={2}>
                        <MDBox >
                          <MDTypography variant="h6" style={{ fontWeight: "500" }}>Material Grade</MDTypography>
                          <MDInput
                            type="text"
                            name="materialGrade"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.materialGrade}
                            error={formik.touched.materialGrade && Boolean(formik.errors.materialGrade)}
                            inputProps={{ style: { height: "10px" } }}
                          />
                          {formik.touched.materialGrade && formik.errors.materialGrade && (
                            <TextError msg={formik.errors.materialGrade} />
                          )}
                        </MDBox>
                      </Grid>
                      {/* <Grid item xs={12} lg={4}>
                              <MDBox ml={1} mb={1} >
                              <MDTypography variant="h6">User</MDTypography>
                              <MDInput
                              type="text"
                              name="User"
                              fullWidth
                              autoComplete="off"
                                              onBlur={formik.handleBlur}
                                              onChange={formik.handleChange}
                                              value={formik.values.User}
                                              error={
                                                formik.touched.User &&
                                                formik.errors.User &&
                                                true
                                                }
                                              inputProps={{
                                                style: {
                                                  height: "10px",
                                                  },
                                                  
                                                  // maxLength: 45,
                                              }}
                                              
                                            />
                                            {formik.touched.User &&
                                              formik.errors.User && (
                                                <TextError msg={formik.errors.User} />
                                              )}
                                          </MDBox>
                                          </Grid> */}
                      <Grid item xs={12} lg={4} mt={2}>
                        <MDBox ml={1}>
                          <MDTypography
                            variant="h6"
                            style={{ fontWeight: "500" }}
                          >
                            {" "}
                            User{" "}
                          </MDTypography>

                          <Select
                            // isDisabled={activityIdSelected ? false : true}
                            isClearable
                            className="select-css"
                            maxMenuHeight={300}
                            menuPlacement="top"
                            menuPosition="absolute"
                            placeholder="Choose one..."
                            name="User"
                            onBlur={() => {
                              formik.handleBlur({
                                target: { name: "User" },
                              });
                            }}
                            value={userSelected}
                            options={userOptions}
                            onChange={(selectedOption) => {
                              handleChangeUser(selectedOption);
                              // getZonesByWarehouse(selectedOption?.value);
                              formik.setFieldValue("User", selectedOption);
                            }}
                          />
                          {formik.touched.User && formik.errors.User && (
                            <TextError msg={formik.errors.User} />
                          )}
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={4} mt={2}>
                        <MDBox ml={1}>
                          <MDTypography variant="h6">
                            Completion Date
                          </MDTypography>
                          <MDInput
                            type="date"
                            name="CompletionDate"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.CompletionDate}
                            error={
                              formik.touched.CompletionDate &&
                              formik.errors.CompletionDate &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },

                              // maxLength: 45,
                            }}
                          />
                          {formik.touched.CompletionDate &&
                            formik.errors.CompletionDate && (
                              <TextError msg={formik.errors.CompletionDate} />
                            )}
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={4} mt={2}>
                        <MDBox >
                          <MDTypography variant="h6">
                            Carbon Footprint(kg CO₂)
                          </MDTypography>
                          <MDInput
                            type="text"
                            name="carbonFootprint"

                            // placeholder="Enter number"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.carbonFootprint}
                            error={
                              formik.touched.carbonFootprint &&
                              formik.errors.carbonFootprint &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },

                              // maxLength: 45,
                            }}
                          />
                          {formik.touched.carbonFootprint &&
                            formik.errors.carbonFootprint && (
                              <TextError msg={formik.errors.carbonFootprint} />
                            )}
                        </MDBox>
                      </Grid>

                      <Grid item xs={12} lg={4} mt={2}>
                        <MDBox ml={1}>
                          <MDTypography variant="h6">
                            Electricity Consumption(kWh)
                          </MDTypography>
                          <MDInput
                            type="text"
                            name="electricityConsumption"

                            // placeholder="Enter number"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.electricityConsumption}
                            error={
                              formik.touched.electricityConsumption &&
                              formik.errors.electricityConsumption &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },

                              // maxLength: 45,
                            }}
                          />
                          {formik.touched.electricityConsumption &&
                            formik.errors.electricityConsumption && (
                              <TextError msg={formik.errors.electricityConsumption} />
                            )}
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={4} mt={2}>
                        <MDBox ml={1}>
                          <MDTypography variant="h6">
                            Water Consumption(L)
                          </MDTypography>
                          <MDInput
                            type="text"
                            name="waterConsumption"

                            // placeholder="Enter number"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.waterConsumption}
                            error={
                              formik.touched.waterConsumption &&
                              formik.errors.waterConsumption &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },

                              // maxLength: 45,
                            }}
                          />
                          {formik.touched.waterConsumption &&
                            formik.errors.waterConsumption && (
                              <TextError msg={formik.errors.waterConsumption} />
                            )}
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={4} mt={2}>
                        <MDBox >
                          <MDTypography variant="h6">
                            Made In
                          </MDTypography>
                          <MDInput
                            type="text"
                            name="madeIn"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.madeIn}
                            error={
                              formik.touched.madeIn &&
                              formik.errors.madeIn &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },

                              // maxLength: 45,
                            }}
                          />
                          {formik.touched.madeIn &&
                            formik.errors.madeIn && (
                              <TextError msg={formik.errors.madeIn} />
                            )}
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={4} mt={2}>
                        <MDBox ml={1} >
                          <MDTypography variant="h6">
                            Quality Yield
                          </MDTypography>
                          <MDInput
                            type="text"
                            name="qualityYield"

                            // placeholder="Enter number"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.qualityYield}
                            error={
                              formik.touched.qualityYield &&
                              formik.errors.qualityYield &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },

                              // maxLength: 45,
                            }}
                          />
                          {formik.touched.qualityYield &&
                            formik.errors.qualityYield && (
                              <TextError msg={formik.errors.qualityYield} />
                            )}
                        </MDBox>
                      </Grid>
                      <Grid item xs={12} lg={4} mt={2}>
                        <MDBox ml={1}>
                          <MDTypography variant="h6">
                            Waste Generated
                          </MDTypography>
                          <MDInput
                            type="text"
                            name="wasteGenerated"

                            // placeholder="Enter number"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.wasteGenerated}
                            error={
                              formik.touched.wasteGenerated &&
                              formik.errors.wasteGenerated &&
                              true
                            }
                            inputProps={{
                              style: {
                                height: "10px",
                              },

                              // maxLength: 45,
                            }}
                          />
                          {formik.touched.wasteGenerated &&
                            formik.errors.wasteGenerated && (
                              <TextError msg={formik.errors.wasteGenerated} />
                            )}
                        </MDBox>
                      </Grid>




                      <Grid item xs={12} lg={4} mt={2}>
                        <MDBox>
                          <MDTypography variant="h6">Production Batch / Casting</MDTypography>
                          <MDInput
                            type="text"
                            name="productionCastingBatch"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.productionCastingBatch}
                            error={formik.touched.productionCastingBatch && Boolean(formik.errors.productionCastingBatch)}
                            inputProps={{ style: { height: "10px" } }}
                          />
                          {formik.touched.productionCastingBatch && formik.errors.productionCastingBatch && (
                            <TextError msg={formik.errors.productionCastingBatch} />
                          )}
                        </MDBox>
                      </Grid>



                      {/* Casting Process */}
                      <Grid item xs={12} lg={4} mt={2}>
                        <MDBox ml={1}>
                          <MDTypography variant="h6">Casting Process</MDTypography>
                          <MDInput
                            type="text"
                            name="castingProcess"
                            fullWidth
                            autoComplete="off"
                            onBlur={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.castingProcess}
                            error={formik.touched.castingProcess && Boolean(formik.errors.castingProcess)}
                            inputProps={{ style: { height: "10px" } }}
                          />
                          {formik.touched.castingProcess && formik.errors.castingProcess && (
                            <TextError msg={formik.errors.castingProcess} />
                          )}
                        </MDBox>
                      </Grid>




                      <Grid item xs={12} mt={2}>
                        <Collapse in={isErrorAllocateItem}>
                          <Alert
                            style={{ marginBottom: "10px" }}
                            severity="error"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsErrorAllocateItem(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            {errorMsg}
                          </Alert>
                        </Collapse>
                        <Collapse in={isSuccessAllocateItem}>
                          <Alert
                            style={{ marginBottom: "10px" }}
                            severity="success"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsSuccessAllocateItem(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            Created Successfully
                          </Alert>
                        </Collapse>
                      </Grid>

                      {/* Submit Button */}
                      <MDButton
                        color="info"
                        fullWidth
                        type="submit"
                        disabled={
                          // !formik.isValid ||

                          allocateButtonName === "Please wait..."
                        }
                      >
                        {allocateButtonName}
                      </MDButton>
                    </Grid>
                  </MDBox>
                </MDBox>
              </MDCard>
            </Modal>
          </Grid>
        </Grid>
      </MDBox>
      {loading && (
        <Backdrop
          sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <ToastContainer />
      {/* <Footer /> */}
    </div>
    // </DashboardLayout>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
    warehouses: state.warehouses,
    getFgOperationReducer: state.getFgOperationReducer,
    itemMaster: state.itemMaster,
    zonesByWarehouse: state.zonesByWarehouse,
    getLevel1ByLevelReducer: state.getLevel1ByLevelReducer,
    getLevel2ByLevelReducer: state.getLevel2ByLevelReducer,
    getLevel3ByLevelReducer: state.getLevel3ByLevelReducer,
    getUsersForFGReducer: state.getUsersForFGReducer,
    getAcnReducer: state.getAcnReducer,
    openBinsByWarehouse: state.openBinsByWarehouse,
    getRelationLocationReducer: state.getRelationLocationReducer,
    getWarehouseByMovementReducer: state.getWarehouseByMovementReducer,
    levelsByWarehouseReducer: state.levelsByWarehouseReducer,
    getDynamicColumnReducer: state.getDynamicColumnReducer,
    getDPPReducer: state.getDPPReducer,
    getPOnumberFGReducer: state.getPOnumberFGReducer,
    getPOnumberReducer: state.getPOnumberReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
    getWarehouses: (jwtToken) => dispatch(getWarehouses(jwtToken)),
    getFgOperation: (dppId, jwtToken) => dispatch(getFgOperation(dppId, jwtToken)),
    getDppIds: (jwtToken) => dispatch(getDppIds(jwtToken)),
    getItemMaster: (jwtToken) => dispatch(getItemMaster(jwtToken)),
    getZonesByWarehouse: (id, jwtToken) =>
      dispatch(getZonesByWarehouse(id, jwtToken)),
    getLevel1ByLevel: (warehouseId, parentId, jwtToken) =>
      dispatch(getLevel1ByLevel(warehouseId, parentId, jwtToken)),
    getLevel2ByLevel: (warehouseId, parentId, jwtToken) =>
      dispatch(getLevel2ByLevel(warehouseId, parentId, jwtToken)),
    getLevel3ByLevel: (warehouseId, parentId, jwtToken) =>
      dispatch(getLevel3ByLevel(warehouseId, parentId, jwtToken)),
    getLevel4ByLevel: (warehouseId, parentId, jwtToken) =>
      dispatch(getLevel4ByLevel(warehouseId, parentId, jwtToken)),
    getAcn: (jwtToken) => dispatch(getAcn(jwtToken)),
    getOpenBinsByWarehouseAndZone: (id, zoneId, jwtToken) =>
      dispatch(getOpenBinsByWarehouseAndZone(id, zoneId, jwtToken)),
    createFG: (payload, jwtToken) => dispatch(createFG(payload, jwtToken)),
    deletefG: (durabilityId, jwtToken) =>
      dispatch(deletefG(durabilityId, jwtToken)),
    uploadForProduction: (payload, jwtToken) =>
      dispatch(uploadForProduction(payload, jwtToken)),
    getRelationLocation: (jwtToken) => dispatch(getRelationLocation(jwtToken)),
    getWarehousesByMovement: (activityIdSelected, jwtToken) =>
      dispatch(getWarehousesByMovement(activityIdSelected, jwtToken)),
    editFg: (payload, jwtToken) => dispatch(editFg(payload, jwtToken)),
    getUsersForFG: (jwtToken) => dispatch(getUsersForFG(jwtToken)),
    getInsertPoNumberProduction: (Ponumber, dppId, jwtToken) =>
      dispatch(getInsertPoNumberProduction(Ponumber, dppId, jwtToken)),
    getPoNumberByDppId: (dppId, jwtToken) =>
      dispatch(getPoNumberByDppId(dppId, jwtToken)),


    getDynamicColumn: (userId, subModuleId, jwtToken) =>
      dispatch(getDynamicColumn(userId, subModuleId, jwtToken)),
    createDynamicColumn: (payload, jwtToken) =>
      dispatch(createDynamicColumn(payload, jwtToken)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FGOPERATIONLOG);
